import type { InfiniteData } from '@tanstack/react-query'
import { queryClient } from '@core/Data/ReactQuery'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import type { BetLoopSharedBet } from '@core/Areas/BetLoop/types'
import { isKambiSharedCoupon } from '@core/Areas/BetLoop/helpers/typeGuards/isKambiSharedCoupon'

export const patchFeedDataShareWithBettingClosed = (postId: PostId) => {
  queryClient.setQueriesData<InfiniteData<BetLoopSharedBet[]>>(
    { queryKey: queryKeys.betLoopSharedBetsFeedBase() },
    currentCachedData => {
      if (!currentCachedData) return currentCachedData

      return {
        ...currentCachedData,
        pages: currentCachedData.pages.map(updateRacingBetStatusForPost(postId)),
      }
    }
  )
}

// =============
// Local Helpers
// =============

const updateRacingBetStatusForPost =
  (postId: PostId) =>
  (page: BetLoopSharedBet[]): BetLoopSharedBet[] => {
    return page.map(bet => {
      if (isKambiSharedCoupon(bet.ticket)) {
        // TODO: Force betting closed for kambi status
        return bet
      }

      return Number(bet.postId) === Number(postId)
        ? { ...bet, ticket: { ...bet.ticket, status: 'BettingClosed' } }
        : bet
    })
  }

// =====
// Types
// =====

type PostId = BetLoopSharedBet['postId']
